<template>
  <validation-provider
    class="col-span-1"
    tag="div"
    :name="fieldName"
    :rules="rules"
    mode="passive"
    v-slot="{ errors }"
  >
    <form-label :for="fieldName">
      Policy Holder's DOB
      <span class="text-xs" v-if="internalValue">(MM/DD/YYYY)</span>
      <span v-if="isRequired" class="leading-none text-red-400">*</span>
    </form-label>
    <form-input
      v-if="isPolicyHolder"
      :id="fieldName"
      :value="internalValue"
      :readonly="isPolicyHolder"
    ></form-input>
    <form-input
      v-else
      :id="fieldName"
      v-model="internalValue"
      v-mask="'##/##/####'"
      :readonly="isPolicyHolder"
      :placeholder="!isPolicyHolder ? 'MM/DD/YYYY' : ''"
      @input="onInput"
    ></form-input>
    <form-alert-msg v-if="errors[0]">{{ errors[0] }}</form-alert-msg>
    <template v-if="internalErrors">
      <form-alert-msg v-for="(error, index) in internalErrors" :key="index">{{
        error
      }}</form-alert-msg>
    </template>
  </validation-provider>
</template>

<script>
import { FormInput, FormLabel, FormAlertMsg } from "@/components/Form/";
import { ValidationProvider, extend } from "vee-validate";
import { VueMaskDirective } from "v-mask";
import { required } from "vee-validate/dist/rules";
import { isValidDate } from "@/helper";
extend("required", { ...required, message: "This field is required." });
extend("date_length", {
  ...length,
  message: "This field must be a valid date.",
});
extend("date", {
  validate(value) {
    return isValidDate(value);
  },
  message: "This field must be a valid date",
});

export default {
  components: {
    ValidationProvider,
    FormInput,
    FormLabel,
    FormAlertMsg,
  },
  directives: {
    mask: VueMaskDirective,
  },
  props: ["value", "http-errors", "controls"],
  data() {
    return {
      internalValue: "",
    };
  },
  computed: {
    isPolicyHolder() {
      const isSecondary = this.$vnode.key?.toString().includes('secondary_');
      return isSecondary
          ? this.controls.secondary_is_policy_holder
          : this.controls.is_policy_holder;
    },
    isRequired() {
      return (
        this.$store.state.config?.sameday ||
        this.$store.state.settings.insurance_fields.birth_date_required
      );
    },
    fieldName() {
      return this.$vnode.key;
    },
    rules() {
      return this.isRequired ? "required|date" : "date|date_length:10";
    },
    internalErrors() {
      if (!this.httpErrors) return;
      return this.httpErrors.map((el) => el.replace(/input.insurance./i, ""));
    },
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
    "controls.birth_date": {
      handler(val) {
        if (!this.isPolicyHolder) return;
        this.internalValue = val;
        this.$emit("input:field", this.internalValue);
      },
      immediate: true,
    }
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
    },
  },
  created() {
    const isSecondary = this.$vnode.key?.toString().includes('secondary_');
    const prefix = isSecondary ? 'secondary_' : '';

    // Create dynamic watchers
    this.$watch(`controls.${prefix}is_policy_holder`, {
      handler(val) {
        this.internalValue = val ? this.controls[`birth_date`] : "";
        this.$emit("input:field", this.internalValue);
      },
    });
  }
};
</script>
